import { Heading } from "../../components/heading/Heading"
import { P } from "../../components/p/P"
import { Card, CardsWrapper, Icon, IconWrapper, WhatWeOfferWrapper } from "./styles"
import HouseIcon from './img/home.png'
import EntertainmentIcon from './img/video.png'
import LandIcon from './img/location.png'
import BagIcon from './img/shopping-bag.png'
import CheersIcon from './img/cheers.png'
import FoodIcon from './img/dish.png'
import GameIcon from './img/console.png'
import ParkingIcon from './img/parking.png'

export const WhatWeOffer = () => {
    const cardsData = [
        {
            title: '200 Shops In 3 Floors',
            icon: HouseIcon
        },
        {
            title: 'Entertainment Zone',
            icon: EntertainmentIcon
        },
        {
            title: '100 Sqft To 1000 Sqft Shops',
            icon: LandIcon
        },
        {
            title: 'A Convenient Shopping Experience',
            icon: BagIcon
        },
        {
            title: 'Rooftop Bar',
            icon: CheersIcon
        },
        {
            title: 'Food Court',
            icon: FoodIcon
        },
        {
            title: 'Dual Level Parking',
            icon: ParkingIcon
        },
        {
            title: 'Game Zone',
            icon: GameIcon
        },
    ]
    return (
        <WhatWeOfferWrapper>
            <Heading level={2}>What We Offer</Heading>
            <P>A full-fledge high street retail fiesta.</P>
            <CardsWrapper>
                {
                    cardsData.map((item, idx) => (
                            <Card key={idx}>
                                <IconWrapper>
                                    <Icon src={item.icon} />
                                </IconWrapper>
                                <P>{item.title}</P>
                            </Card>
                    ))
                }
            </CardsWrapper>
        </WhatWeOfferWrapper>
    )
}